import $ from 'jquery';
import contentTemplate from 'properties/style/advanced-border.ejs';
import { pickerCfg } from 'pickerCfg';
import BasePropertyView from 'BasePropertyView'
import themeService from 'ThemeService';
import undoService from 'UndoService';
import util from 'util/Util.js'
import eventBus from 'EventBus.js'
import textConstants from 'TextConstants.js';
import mobileSyncService from "../../../service/mobile/MobileSyncService";

class StyleAdvancedBorderView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        // Note:  #cornerRadius and #borderSize' are handled on autocompleteselect function
        this.events = {
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus',
            'change input[type=color]': 'updateColorAttributes',
            'change #borderStyle': 'updateAttributes',
            'change #borderColor' : 'updateColorAttributesWithValidation'
        };

        return this;
    }

    updateAttributes(ev, columnModel = undefined, name=undefined, value= undefined) {
        if (!ev) {
            return;
        }
        ev.preventDefault();

        const
            propName = ev.currentTarget.name? ev.currentTarget.name: name,
            propVal = ev.currentTarget.name? ev.currentTarget.value: value,
            model = columnModel || this.model;
        const oldValue = this.model.get(propName);
        let oldFontFamily = themeService.resolveThemeFont('fontFamily', model.get('titleFontFamily'));
        let oldTitleHeight = model.get('titleHeight');
        let oldPropVal=model.get(propName);
        let height=model.get('titleHeight');

        if( propName === 'titleFontSize' && model.get('factoryKey') === 'control_group' && model.get('titleText') !== '') {
            const fontFamily = themeService.resolveThemeFont('fontFamily', model.get('titleFontFamily'));
            height = util.measureTextHeight(model.get('titleText'), fontFamily + ',' + propVal + ',normal,normal', util.extractNum(model.get('width')));

            if (Number(height) > Number(model.get('titleHeight'))) {
                model.set('titleHeight', height, {silent: true});
            }

        } else if (columnModel && dropdownPropSet.has(propName)) {
            // We know it's a column because we have a columnModel.
            // So select table column bound control's font option, etc.
            util.selectDropdownItem( propName, propVal);
        }

        if (util.isGroupContainer(model.get('factoryKey'))){
           util.updatePropertyRenderAndSendEvent(propName,propVal,model,this.render.bind(this),'GroupPropertyChange')

        }else{
            model.set(propName, propVal);
        }

        if ( this.isThemeProperty(oldValue) ){
            themeService.deattachTheme(this);
        }

        mobileSyncService.synchronize(this.model, {key: propName, val: propVal });
  
  // TODO undo the deattach from Theme if applies
        undoService.add({
            undo: () =>{
                model.set('titleHeight',oldTitleHeight,{silent:true});
                if (util.isGroupContainer(model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent(propName,oldPropVal,model,this.render.bind(this),'GroupPropertyChange')

                }else{
                    model.set(propName, oldPropVal);
                }
            },
            redo:() => {
                model.set('titleHeight',height,{silent:true});
                if (util.isGroupContainer(model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent(propName,propVal,model,this.render.bind(this),'GroupPropertyChange')
                }else{
                    model.set(propName, propVal);
                }
            }
        },textConstants.UNDO_PROP_CHANGE);
    }

    updateColorAttributes(ev){
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        let oldValue = this.model.get(propName);
        console.log('Old Value',oldValue);

        let color = this.resolveColor(propVal);
        // Update model
        if (util.isGroupContainer(this.model.get('factoryKey'))){
            util.updatePropertyRenderAndSendEvent(propName,color,this.model,this.render.bind(this),'GroupPropertyChange')

        }else{
            this.model.set(propName, color);
        }

        if ( this.isThemeProperty(oldValue) ){
            themeService.deattachTheme(this);
        }
        // Update text input
        $('#' + propName).val(color);
        mobileSyncService.synchronize(this.model, {key: propName, val: propVal });

      // TODO:  undo deattach from theme

        undoService.add({
            undo: () =>{
                // Update model
                if (util.isGroupContainer(this.model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent(propName,oldValue,this.model,this.render.bind(this),'GroupPropertyChange')
                }else{
                    this.model.set(propName, oldValue);
                }

                let oldColor = this.resolveColor(oldValue);
                // Update text input
                $('#' + propName).val(oldColor);

            },
            redo:() => {
                // Update model
                if (util.isGroupContainer(this.model.get('factoryKey'))){
                    util.updatePropertyRenderAndSendEvent(propName,color,this.model,this.render.bind(this),'GroupPropertyChange')

                }else{
                    this.model.set(propName, color);
                }

                let newColor = this.resolveColor(propVal);

                // Update text input
                $('#' + propName).val(newColor);
            }
        },textConstants.UNDO_PROP_CHANGE)
    }

    updateColorAttributesWithValidation(ev){
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        let oldValue = this.model.get(propName);

        undoService.add({
            undo: () =>{
                if (util.isValidColorcode(oldValue)) {
                    let color = this.resolveColor(oldValue);
                    this.model.set(propName, color);
                }
                this.render();

            },
            redo:() => {
                if (util.isValidColorcode(propVal)) {
                    let color = this.resolveColor(propVal);
                    this.model.set(propName, color);
                }
                this.render();
            }
        },textConstants.UNDO_PROP_CHANGE);


        if (util.isValidColorcode(propVal)) {
            let color = this.resolveColor(propVal);
            this.model.set(propName, color);

            if ( this.isThemeProperty(oldValue) ){
                themeService.deattachTheme(this);
            }

            return true;
        }

        // Call render if invalid color
        this.render();
        return false;
    }


    updateForm() {
        //set selected index to model value
        if (this.model.get('cornerRadius')) {
            const q = `option[value="${this.resolveThemeBorderProperty('cornerRadius')}"]`;
            $('#cornerRadius').find(q).attr('selected', true);
        }

        if (this.model.get('borderStyle')) {
            const q = `option[value="${this.resolveThemeBorderProperty('borderStyle')}"]`;
            $('#borderStyle').find(q).attr('selected', true);

            let borderStyle = this.isThemeProperty(this.model.get('borderStyle')) ? this.resolveThemeBorderProperty('borderStyle') : this.model.get('borderStyle');

            if(borderStyle === 'none'){
                $(` #cornerRadius + span.custom-combobox > input,
                    #borderSize + span.custom-combobox > input,
                    #propStyleAdvancedBorder input[type=text],
                    #propStyleAdvancedBorder input[type=color]`).prop('disabled',true);
                    $("#cornerRadius + span.custom-combobox a").css('pointer-events','none');
                    $("#borderSize + span.custom-combobox a").css('pointer-events','none');
            }
            else{
                $(` #cornerRadius + span.custom-combobox > input,
                    #cornerRadius + span.custom-combobox a,
                    #borderSize + span.custom-combobox > input,
                    #borderSize + span.custom-combobox a,
                    #propStyleAdvancedBorder input[type=text],
                    #propStyleAdvancedBorder input[type=color]`).prop('disabled',false);
                    $("#cornerRadius + span.custom-combobox a").css('pointer-events','all');
                    $("#borderSize + span.custom-combobox a").css('pointer-events','all');
            }
        }
        if (this.model.get('borderSize')) {
            const q = `option[value="${this.resolveThemeBorderProperty('borderSize')}"]`;
            $('#borderSize').find(q).attr('selected', true);
        }
    }

    render() {
        super.render();

        const props = this.model.toJSON();
        props.borderColor = themeService.resolve(props.borderColor);
        props.cornerRadius = isNaN(this.resolveThemeBorderProperty('cornerRadius')) ? '0' :
            this.resolveThemeBorderProperty('cornerRadius');
        props.borderSize = this.resolveThemeBorderProperty('borderSize');
        props.borderStyle = this.resolveThemeBorderProperty('borderStyle');

        this.$el.html(this.template(props));

        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        this.prepareComboWidget(this.$el);

        $("#cornerRadius", this.$el).combobox({
            value: props.cornerRadius
            // PF-4477 Property being updated by updateAttributes function already.
        });

        $("#borderSize", this.$el).combobox({
            value: props.borderSize
            // PF-4477 Property being updated by updateAttributes function already.
        });

        this.updateForm();
        this.delegateEvents();

        return this;
    }

    prepareComboWidget($el) {
        let selfThis = this;
        $.widget("custom.combobox", {
            _create: function () {
                this.wrapper = $("<span>")
                    .addClass("custom-combobox")
                    .insertAfter(this.element);

                this.element.hide();
                this._createAutocomplete(this.options);
                this._createShowAllButton();
            },

            _createAutocomplete: function (options) {
                var selected = this.element.children(":selected");

                this.input = $("<input style='width:35px;'>", {
                    maxLength: 3
                })
                    .appendTo(this.wrapper)
                    .addClass("custom-combobox-input ui-widget ui-widget-content ui-corner-left")
                    .val(options.value)
                    .autocomplete({
                        classes: {
                            "ui-autocomplete": "custom-autocomplete"
                        },
                        delay: 0,
                        minLength: 0,
                        source: $.proxy(this, "_source"),
                        appendTo: $el,
                        search: options.value
                    });

                this._on(this.input, {
                    input: function (e, param) {
                        var value = e.currentTarget.value.replace(/[^[0-9]+(\.[0-9]{1,2})?$]/g, '');

                        this.input.val(value);
                        this.element.val(value);
                        this.input.autocomplete( "disable" );
                    }, //PF-2105 - Forms/Reports - Font size (general)
                    change: function(e, param){
                        let name = event.currentTarget.parentElement.parentElement.children[1].name;
                        let value = e.currentTarget.value.replace(/[^[0-9]+(\.[0-9]{1,2})?$]/g, '');
                        this._trigger("change", null, { value: value });
                        this._trigger("select", e, { item: value });
                        selfThis.updateAttributes(e, null, name, value);
                    },
                    autocompleteselect: function (event, ui) {
                        let name = event.currentTarget.parentElement.parentElement.children[1].name;
                        let value =  ui.item.value;
                        ui.item.option.selected = true;
                        this._trigger("change", null, { value: value });
                        this._trigger("select", event, { item: ui.item.option });
                        selfThis.updateAttributes(event, null, name, value);
                    }
                });
            },

            _createShowAllButton: function () {
                var input = this.input,
                    element = this.element,
                    wasOpen = false;

                $("<a>")
                    .attr("tabIndex", -1)
                    .appendTo(this.wrapper)
                    .button({
                        icons: {
                            primary: "ui-icon-triangle-1-s"
                        },
                        text: false
                    })
                    .removeClass("ui-corner-all")
                    .addClass("custom-combobox-toggle ui-corner-right")
                    .on("mousedown", function () {
                        wasOpen = input.autocomplete("widget").is(":visible");
                    })
                    .on("click", function () {
                        input.trigger("focus");

                        // Close if already visible
                        if (wasOpen) {
                            return;
                        }
                        // Pass empty string as value to search for, displaying all results
                        input.autocomplete("search", "20");
                    });
            },

            _source: function (request, response) {
                response(this.element.children("option").map(function () {
                    var text = $(this).text();
                    return {
                        label: text,
                        value: text,
                        option: this
                    };
                }));
            },

            _destroy: function () {
                this.wrapper.remove();
                this.element.show();
            }
        });
    }
}

export default StyleAdvancedBorderView;